import Image from "@/ui/Image";
import { Container, Row, Col } from "react-bootstrap";
import ChevronDown from "@/assets/ChevronDown.svg";

import classes from "./styles.module.scss";

export default function TileGroup({ items }) {
  return (
    <Container className={classes.container}>
      <Row className={classes.row}>
        {items.map((item, key) => (
          <Col key={key}>
            <div className={classes.title}>
              <span>{item.title}</span>
            </div>
            <div className={classes.tile__group}>
              {item.tile_group.map((tile, key) => (
                <div className={classes.tile} key={key}>
                  <Image img={tile.image} alt={tile.label} size="282x188" />
                  <a className={classes.tile__mask} href={tile.link}>
                    <span>{tile.label}</span>
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.see__more}>
              <a href={item.bottom_label_link}>
                {item.bottom_label} <ChevronDown style={{ width: 12, height: 12 }} />
              </a>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
